import axios from 'axios';
import config from '../../../static/config.json';


const actions = {
    //话题置顶推荐 前6条
    getQueryTopic({
        rootState
    }, body) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/theme/query/topic`, body, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    getTopicOne({
        rootState
    }, id) {
        return new Promise((resolve, reject) => {
            axios.get(`${config.https.api}/api/v3/theme?id=${id}`, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    AddTopic({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/theme`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    // 获取我的关注
    // getThemeFollow_me({
    //     rootState
    // }, opt){
    //   return new Promise((resolve, reject) => {
    //     fly.post(`${config.https.apinew}/api/v1/themefollow/me`, opt, rootState.header).then(({
    //           data
    //           }) => {
    //       console.log(data, '12321')
    //       if (data) {
    //         resolve(data);
    //       }
    //     });
    //   }).catch(err => {
    //     console.log(err);
    //   });
    // },
    // 获取ta的关注x
    // getThemeFollow_ta({
    //     rootState
    //   }, opt){
    //   return new Promise((resolve, reject) => {
    //     fly.post(`${config.https.apinew}/api/v1/themefollow/ta`, opt, rootState.header).then(({
    //           data
    //           }) => {
    //       console.log(data, '12321')
    //       if (data) {
    //         resolve(data);
    //       }
    //     });
    //   }).catch(err => {
    //     console.log(err);
    //   });
    // },
    // 获取已关注话题的用户
    // getThemeFollow_query({
    //     rootState
    //   }, opt){
    //   return new Promise((resolve, reject) => {
    //     fly.post(`${config.https.apinew}/api/v1/themefollow/query`, opt, rootState.header).then(({
    //         data
    //         }) => {
    //       console.log(data, '12321')
    //       if (data) {
    //         resolve(data);
    //       }
    //     });
    //   }).catch(err => {
    //     console.log(err);
    //   });
    // },
    //获取所有话题
    getTopic({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/theme/page`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    // 分享话题
    TopicShare({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.post(`${config.https.apinew}/api/v1/theme/share`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    // 话题浏览
    TopicView({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/themeview`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //获取详情
    getTopicInfo({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.get(`${config.https.api}/api/v3/theme/info?themeId=${opt.themeId}&memberId=${opt.memberId}`, rootState.header).then(({
                data
            }) => {
                console.log(data, '123211111')
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //获取供需详情
    getSupply_detail({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.get(`${config.https.apinew}/api/v1/supplydemand?supplyDemandId=${opt.supplyDemandId}&memberId=${opt.memberId}`, {}, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //分享供需
    supplyDemandShare({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.post(`${config.https.apinew}/api/v1/supplydemandshare`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        })
    },
    // 供需发表评论
    supplyDemandcomment({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.post(`${config.https.apinew}/api/v1/supplydemandcomment`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    // 获取评论列表
    getsupplyDemandcomment({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.post(`${config.https.apinew}/api/v1/supplydemandcomment/page`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //获取热点供需
    getHotSupply({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.post(`${config.https.apinew}/api/v1/supplydemand/page/hot`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //供需详情
    SupplydemandInfo({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.get(`${config.https.apinew}/api/v1/supplydemand/info?supplyDemandId=${opt.supplyDemandId}&memberId=${opt.memberId}`, {}, rootState.header).then(({
                data
            }) => {
                console.log(data);
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },

    //发布供需
    supplyDemand({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/supplydemand`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },

    //获取供需列表
    supplyDemandPage({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/supplydemand/page`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //分页获取讨论
    TalkPage({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/talk/page/view`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //讨论详情
    TalkDetail({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.get(`${config.https.api}/api/v3/talk?id=${opt.talkId}&memberId=${opt.memberId}`, rootState.header).then(({
                data
            }) => {
                console.log(data);
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //讨论详情
    TalkComment({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/talkcomment/page`, opt, rootState.header).then(({
                data
            }) => {
                console.log(data);
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    // 发布评论
    TalkCommentcontent
        ({
            rootState
        }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/talkcomment`, opt, rootState.header).then(({
                data
            }) => {
                console.log(data);
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //发表讨论
    TalkRelease({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/talk`, opt, rootState.header)
                .then(({ data }) => {
                    console.log(data);
                    if (data) {
                        resolve(data);
                    }
                });
        }).catch(err => {
            console.log(err);
        });
    },
    //获取名人列表（可查询名人最新最新讨论）
    getCeleBrityList({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.post(`${config.https.apinew}/api/v1/celebrity/query/short/with-talk`, opt, rootState.header).then(({
                data
            }) => {
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //讨论点赞
    TalkLike
        ({
            rootState
        }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/talklike`, opt, rootState.header).then(({
                data
            }) => {
                console.log(data);
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //移除讨论点赞
    TalkLikeRemove
        ({
            rootState
        }, opt) {
        return new Promise((resolve, reject) => {
            axios.delete(`${config.https.api}/api/v3/talklike/remove?talkId=${opt.talkId}&memberId=${opt.memberId}`, rootState.header).then(({
                data
            }) => {
                console.log(data);
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //讨论分享
    TalkShare
        ({
            rootState
        }, opt) {
        return new Promise((resolve, reject) => {
            fly.post(`${config.https.apinew}/api/v1/talk/share`, opt, rootState.header).then(({
                data
            }) => {
                console.log(data);
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //讨论浏览
    TalkView
        ({
            rootState
        }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/talkview`, opt, rootState.header).then(({
                data
            }) => {
                console.log(data);
                if (data) {
                    resolve(data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //重新编辑供需-获取供需信息
    getSupplyEdit({
        rootState
    }, id) {
        return new Promise((resolve, reject) => {
            fly.get(`${config.https.apinew}/api/v1/supplydemand?id=${id}`, {}, rootState.header).then(({
                data
            }) => {
                if (data && data.data) {
                    resolve(data.data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //再次编辑供需
    editSupply({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.put(`${config.https.api}/api/v3/supplydemand/patch?id=${opt.id}`, opt, rootState.header).then(data => {
                console.log(data);
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //名人详情（根据memberId获取用户信息）
    getCeleDetails({
        rootState
    }, id) {
        return new Promise((resolve, reject) => {
            fly.get(`${config.https.apinew}/api/v1/member/by-memberid?memberId=${id}`, {}, rootState.header).then(({
                data
            }) => {
                if (data && data.data) {
                    resolve(data.data);
                }
            });
        }).catch(err => {
            console.log(err);
        });
    },
    //是否关注这个名人
    getIsCeleFollow({
        rootState
    }, opt) {
        return new Promise((resolve, reject) => {
            fly.get(`${config.https.apinew}/api/v2/memberfollow/count/user?taMemberId=${opt.taMemberId}&memberId=${opt.memberId}`, {}, rootState.header).then(({
                data
            }) => {
                resolve(data);
            });
        }).catch(err => {
            console.log(err);
        });
    },

    //再次编辑讨论
    EditTalk({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.put(`${config.https.api}/api/v3/talk/patch?id=${opt.id}`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //搜索话题
    TopicSearch({
        rootState,
        commit
    }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/theme/search`, opt, rootState.header).then(data => {
                console.log(data);
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    //供需浏览
    AddSupplydemandView({ rootState, commit }, opt) {
        return new Promise((resolve, reject) => {
            fly.post(`${config.https.apinew}/api/v1/supplydemandviewer`, opt, rootState.header).then(data => {
                console.log(data);
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    // 头条接口
    // 供需详情 
    getSupplyDemand({ rootState, commit }, id) {
        return new Promise((resolve, reject) => {
            axios.get(`${config.https.api}/api/v3/supplydemand?id=${id}`, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    // 供需详情浏览记录 
    addSupplyDemandView({ rootState, commit }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/supplydemandviewer`, opt, rootState.header).then(data => {
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
    // 发表供需详情的评论
    addSupplydemandcomment({ rootState, commit }, opt) {
        return new Promise((resolve, reject) => {
            axios.post(`${config.https.api}/api/v3/supplydemandcomment`, opt, rootState.header).then(data => {
                console.log(data);
                if (data.data) {
                    resolve(data.data);
                }
            }).catch((err) => {
                console.log(err);
            });
        });
    },
}
export default {
    namespaced: true,
    actions,
}
